import stylex from '@stylexjs/stylex';

import { fonts } from '@shared/tokens/fonts.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: anatomy['space-16'],
  },
  actionsContainer: {
    display: 'flex',
    gap: anatomy['size-16'],
    width: '100%',
  },
  containerBtn: {
    fontSize: typography['fontSizeCaption-1'],
    fontFamily: fonts.din2014Regular,
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-1'],
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
    borderTop: `1px solid ${colors.ghostBorder}`,
  },
  segmentsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['space-16'],
    width: '100%',
  },
  segment: {
    borderRadius: anatomy.borderRadiusS,
  },
  loader: {
    margin: '0 auto',
  },
  emptyText: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: colors.primaryText,
  },
  containerText: {
    display: 'flex',
    padding: '8px 0px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: anatomy['space-10'],
  },
});
